import React, { useEffect, useState } from "react"
import { InputField } from "../../../components/InputField"
import { ENDPOINT } from "../../../constants"
import { WLQualification } from "../../../types/wl-management"
import { useAuth } from "../../../contexts/AuthContext"
import WhitelistTable from "./whitelist-table"

const WhitelistManagement = () => {
  const { getUserJWT } = useAuth()

  const [searchText, setSearchText] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [wlQualifications, setWlQualifications] = useState<WLQualification[]>(
    []
  )

  const getQualificationData = async () => {
    const userJWT = getUserJWT()
    try {
      setIsLoading(true)
      const res = await fetch(ENDPOINT.WL_QUALIFICATION, {
        headers: {
          "Content-type": "application/json",
          Authorization: userJWT ? `Bearer ${userJWT}` : "",
        },
      })
      const data = (await res.json()) as {
        count: number
        success: boolean
        data: WLQualification[]
      }
      setWlQualifications(data.data)
      setIsLoading(false)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSearch = (e: any) => {
    setSearchText(e.target.value)
  }

  useEffect(() => {
    getQualificationData()
  }, [])
  return (
    <main className="flex flex-col pt-8 lg:pt-10 p-6 h-[calc(100vh_-_114px)]">
      <div className="mt-0 flex flex-row mb-4 justify-between items-center sm:flex-row">
        <h1 className="font-semibold text-3xl text-left">
          Whitelist Management
        </h1>
      </div>
      <div>
        <InputField
          type="text"
          value={searchText}
          onChange={handleSearch}
          className="w-full mt-2 mb-1 mx-0 bg-gray-90 border-gray-80 rounded-full"
          placeholder="Search for username, wallet address, discord or twitter handle"
        />
      </div>
      <WhitelistTable
        isLoading={isLoading}
        qualifications={wlQualifications}
        search={searchText}
      />
    </main>
  )
}

export default WhitelistManagement
